import { isWebPushNotificationSupported } from './isWebPushNotificationSupported';

import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { WebPushNotificationsOptions } from 'owa-outlook-service-options';
import { WebPushDiscoveryProps } from './components/WebPushDiscovery';
import { loadLocalWebPushUserSetting } from './localWebPushUserSettingActions';
import { getLocalWebPushUserSettingStore } from './store/store';
import { LocalWebPushUserSetting } from './schema/LocalWebPushUserSetting';
import { getUserPreferenceIdentifier } from './utils/getUserPreferenceIdentifier';
import { logEnableStart, logDisableStart, logWorkFlowEnd } from './optics/webpushOptics';

import { ComponentClass } from 'react';
export { ComponentClass };

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "Webpush-Notifications", webpackPrefetch: true */ './lazyIndex')
);

let lazybootStrapWebPushService = new LazyAction(lazyModule, m => m.bootStrapWebPushService);

export const lazyUserInitiatedWebPushSetupWorkflow = new LazyImport(
    lazyModule,
    m => m.userInitiatedWebPushSetupWorkflow
);

export const lazyUserInitiatedWebPushDisableWorkflow = new LazyImport(
    lazyModule,
    m => m.userInitiatedWebPushDisableWorkflow
);

export const lazyUnsubscribeWebPushNotifications = new LazyImport(lazyModule, m => m.unsubscribe);

export const lazyShouldShowWebPushLightning = new LazyImport(
    lazyModule,
    m => m.shouldShowWebPushLightning
);

export const lazyLoadWebPushOptions = new LazyImport(lazyModule, m => m.loadWebPushOptions);

export const WebPushDiscovery = createLazyComponent(lazyModule, m => m.WebPushDiscovery);

export {
    WebPushNotificationsOptions,
    WebPushDiscoveryProps,
    loadLocalWebPushUserSetting,
    getUserPreferenceIdentifier,
    isWebPushNotificationSupported,
    getLocalWebPushUserSettingStore,
    LocalWebPushUserSetting,
    logEnableStart,
    logDisableStart,
    logWorkFlowEnd,
};

runAfterInitialRender(() => {
    if (isWebPushNotificationSupported(window)) {
        lazybootStrapWebPushService.importAndExecute(window);
    }
});
